import IRequest from "../../IRequest"

export type TBancos = {
    codigo: string,
    nome: string,
    id: number,
    logo_imagem: string,
    integracoes_possiveis: string
}

export interface IBancos {
    reqBancos: IRequest<TBancos>,
    dataBancos: TBancos[]
}

export const defValueBanco: TBancos = {
    codigo: "",
    nome: "",
    id: 0,
    logo_imagem: "",
    integracoes_possiveis: ""
}
